import { mapGetters } from 'vuex';

export default {
  name: 'PreferencesChooseMixin',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      loaded: false,
      userPreferences: [],
      // preferences: [],
    };
  },
  computed: {
    ...mapGetters('preferences', {
      preferences: 'getPreferences',
    }),
    noAnswerPreferencesIds: function () {
      return this.preferences.filter((v) => v.no_answer).map((v) => v.id);
    }
  },
  watch: {},
  methods: {
    change: function (event, preference) {
      if (!event.target.checked) {
        return false;
      }

      if (preference.no_answer) {
        this.userPreferences = [preference.id];
      } else {
        this.userPreferences = this.userPreferences.filter((el) => !this.noAnswerPreferencesIds.includes(el));
      }
    },
  },
  mounted() {
    this.$store.dispatch('preferences/load')
      .then(() => this.loaded = true);
  },
};
